import { Link } from 'react-router-dom'
import { Compass } from 'lucide-react'
import { useAuthStore } from '@/stores/authStore'
import { LANDING_ROUTE } from '@/config/roles'
import { PageContainer, EmptyState } from '@/design'

export function NotFound() {
  const user = useAuthStore((s) => s.user)
  const home = user ? LANDING_ROUTE[user.role] : '/login'
  return (
    <PageContainer>
      <EmptyState
        icon={Compass}
        title="Page not found"
        message="The page you're looking for doesn't exist or has moved."
        action={
          <Link to={home} className="mt-1 rounded-md bg-primary px-4 py-2 text-title-sm font-semibold text-white hover:shadow-md">
            Go home
          </Link>
        }
      />
    </PageContainer>
  )
}
